'use client'

const LOCALE_STORAGE_KEY = 'preferred-locale'

export function getStoredLocale(): string {
	if (typeof window === 'undefined') return 'de'
	try {
		return localStorage.getItem(LOCALE_STORAGE_KEY) || getBrowserLocale()
	} catch {
		return 'de'
	}
}

export function setStoredLocale(locale: string): void {
	if (typeof window === 'undefined') return
	try {
		localStorage.setItem(LOCALE_STORAGE_KEY, locale)
		document.cookie = `preferred-locale=${locale}; path=/; max-age=31536000; SameSite=Lax`
	} catch {}
}

export function getBrowserLocale(): string {
	if (typeof window === 'undefined') return 'de'
	const browserLang = navigator.language.split('-')[0]
	return browserLang === 'de' ? 'de' : 'en'
}

export function getInitialLocale(): string {
	const stored = getStoredLocale()
	if (stored && ['en', 'de'].includes(stored)) return stored
	return getBrowserLocale()
}
